@import (reference) '../../../../../../constants/spacing.module.less';

.ship-from-field {
  margin-top: @space-8;
}

.ship-from-field button {
  min-height: 38px;
}

.services-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: @space-8;
  margin-top: @space-8;
}

.step-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: @space-8;
}

.service-tags {
  flex-wrap: wrap;
}

.service-tag {
  background: var(--default--background-color--5);
  border: 1px solid var(--default--border-color--10);
  border-radius: 12px;
  padding: @space-2 @space-8;
  font-size: 12px;
  color: var(--default--text-color--9);
  white-space: nowrap;
}
